import couponsTypes from '../../constants/couponsTypes'
import auth_types from '../../constants/authTypes'
export * from './create'
export * from './delete'
export * from './get'
export * from './getindex'
export * from './publish'
export * from './reset_token'
export * from './update'

const set_coupon_errors = (messages) => {
  return {
    type: couponsTypes.set_errors,
    payload: messages
  }
}

const reset_coupon = () => {
  return {
    type: couponsTypes.reset_coupon
  }
}

const clear_coupon = () => {
  return {
    type: couponsTypes.clear_coupon
  }
}

const update_current_coupon = (response) => {
  return {
    type: auth_types.set_current_coupon,
    payload: response.data.coupon
  }
}

export {
  set_coupon_errors,
  reset_coupon,
  clear_coupon,
  update_current_coupon
}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/index.js